import { Component, OnInit } from '@angular/core';

declare var $;

@Component({
  selector: 'itpx-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    setTimeout($('.mail-link').css({
      'font-family': '\'Open Sans\'',
      'font-size': '16px',
      'color': '#38b6a0',
      'text-decoration': 'none solid rgb(56, 182, 160)'
    }), 10);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/page-not-found/page-not-found.component.ts